import type React from 'react';
import { useEffect } from 'react';
import { X, Truck, MapPin } from 'lucide-react';

interface ShippingDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ShippingDetailsModal: React.FC<ShippingDetailsModalProps> = ({
  isOpen,
  onClose,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center overflow-y-auto">
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      />
      <div className="relative bg-white rounded-lg w-full max-w-2xl mx-4 my-8 max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between z-10">
          <h2 className="text-xl font-semibold">
            Mais detalhes e forma de entrega
          </h2>
          <button
            onClick={onClose}
            className="text-blue-600 hover:text-blue-700 transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        <div className="p-6">
          <h3 className="text-lg font-semibold mb-4">Opções de Envio</h3>

          <div className="space-y-6">
            <div className="pb-6 border-b">
              <div className="flex items-start gap-3 mb-3">
                <Truck className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" />
                <div>
                  <h4 className="text-base font-semibold mb-2">
                    Entrega nacional
                  </h4>
                  <p className="text-sm text-gray-700 mb-2">
                    Atualmente, trabalhamos com os Correios.
                  </p>
                  <p className="text-sm text-gray-700">
                    Todas as entregas nacionais são realizadas por meio deles.
                  </p>
                </div>
              </div>
            </div>

            <div>
              <div className="flex items-start gap-3">
                <MapPin className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                <div>
                  <h4 className="text-base font-semibold mb-2">
                    Entrega local
                  </h4>
                  <p className="text-sm text-gray-700 mb-3">
                    Se o CEP do comprador for o mesmo do vendedor, verifique na
                    descrição do produto as condições de entrega.
                  </p>
                  <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 space-y-2">
                    <p className="text-sm text-gray-700">
                      <span className="font-semibold">⚠️ Atenção:</span> Em
                      alguns casos, mesmo sendo entrega local, distâncias acima
                      de 15 km podem ter taxa adicional, definida pelo vendedor.
                    </p>
                    <p className="text-sm text-gray-700">
                      Recomendamos confirmar essas informações na descrição do
                      produto antes de finalizar a compra.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
